<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Hasil Penilaian per Kategori ({{ filterTahun }})</h2>
    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['filterTahun', 'filterBulan'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      series: [
        {
          data: [0],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  color: '#777777',
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [''],
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: '#78909c',
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    async getHasiPerKategori() {
      try {
        const url =
          this.user.role === 'Pemrakarsa'
            ? `api/dashboard/getHasiPerKategori?tahun=${this.filterTahun}&bulan=${this.filterBulan}`
            : `api/dashboard/getJumlahLaporanKategori?tahun=${this.filterTahun}&bulan=${this.filterBulan}`

        const res = await axios.get(`${this.baseapiPengendalian}${url}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        const resData = res.data.data

        this.series = [
          {
            data: resData.series,
          },
        ]
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: resData.labels,
          },
        }
      } catch (error) {}
    },
  },
  watch: {
    filterTahun: {
      handler(val) {
        this.getHasiPerKategori()
      },
      immediate: true,
    },
    filterBulan() {
      this.getHasiPerKategori()
    },
  },
}
</script>
